import { useCallback, useState } from "react";

const sleep = async (ms: number) => await new Promise((resolve) => setTimeout(resolve, ms));

type BrowserPrinter = {
  send: (data: string | string[]) => Promise<void>;
  isPrinterReady: () => Promise<void>;
};

const reloadBrowserPrinter = async () =>
  await new Promise<BrowserPrinter>((resolve, reject) => {
    // @ts-expect-error BrowserPrint
    window.BrowserPrint.getDefaultDevice(
      "printer",
      // @ts-expect-error Zebra
      (device) => {
        // @ts-expect-error Zebra
        resolve(new window.Zebra.Printer(device));
      },
      (error: Error) => {
        reject(error);
      },
    );
  });

const useBrowserPrinter = () => {
  const [printer, setPrinter] = useState<BrowserPrinter>();

  const reloadPrinter = useCallback(
    async () =>
      await reloadBrowserPrinter()
        .then((device) => {
          setPrinter(device);

          return device;
        })
        .catch((error) => {
          setPrinter(undefined);
          throw error;
        }),
    [],
  );

  return useCallback(
    async (data: string | string[]) => {
      const device = printer ?? (await reloadPrinter());

      await device.send(data);
      await sleep(600);
    },
    [printer, reloadPrinter],
  );
};

export { useBrowserPrinter };
